import { Box, Typography } from "@mui/material";
import React from "react";

import colors from "../../../config/colors";

interface RailCardProps {
	title: string;
	highlighted?: boolean;
	children: React.ReactNode;
}

// The right-rail container. `highlighted` uses the same primary-tinted border
// and elevation as design/wilya-stats-card so the lead card reads as the
// headline number of the page.
function RailCard({ title, highlighted = false, children }: RailCardProps) {
	return (
		<Box
			sx={{
				border: highlighted
					? "1px solid rgba(47, 77, 139, 0.3)"
					: `1px solid ${colors.border}`,
				boxShadow: highlighted
					? "0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 1px 3px rgba(0, 0, 0, 0.12)"
					: "none",
				borderRadius: "15px",
				padding: "16px",
			}}
		>
			<Typography
				component='h3'
				variant='subtitle2'
				sx={{ color: colors.button, fontWeight: 500, mb: 1.5 }}
			>
				{title}
			</Typography>
			{children}
		</Box>
	);
}

export default RailCard;
